import { render, staticRenderFns } from "./DeveloperContact.vue?vue&type=template&id=dcde582e&"
import script from "./DeveloperContact.vue?vue&type=script&lang=js&"
export * from "./DeveloperContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports